<template>
  <div
    class="card"
    style="
      margin: 10px 0;
      background-color: #ffffff99;
      /* border: 2px solid #ec62ea; */
      box-shadow: 0 4px 10px -4px rgba(0, 0, 0, 0.5) !important;
    "
  >
    <div class="card-body" style="background-color: transparent">
      <div
        style="
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin-bottom: 16px;
        "
      >
        <!-- <img
          src="../../assets/img/Xtrim/ingresa-tus-nuevos-referidos-aqui.webp"
          style="width: 100%; max-width: 550px"
        /> -->
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
          "
        >
          <p style="font-size: 18px; font-weight: 900; color: #333333">
            Listado de Ventas Pendientes
          </p>
          <div style="display: flex; align-items: center; gap: 12px">
            <div v-if="isEnterprise && !loading" style="min-width: 260px">
              <input
                v-model="searchTerm"
                @input="applySearch"
                class="form-control enterpriseSearchInput"
                type="text"
                placeholder="Buscar en ventas..."
              />
            </div>
            <button
              v-if="onDashboard && $store.state.user?.type !== 'enterprise'"
              @click="registerReferral"
              class="purpleTag"
            >
              Ingresar Nueva Venta +
            </button>
          </div>
        </div>
      </div>

      <div
        v-if="loading"
        class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        style="padding: 0px"
      >
        <div class="row">
          <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
            <Skeletor :shimmer="true" height="40" width="50%" />
          </div>

          <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
            <Skeletor
              :shimmer="true"
              height="10"
              pill
              width="30%"
              style="margin-bottom: 10px"
            />
            <Skeletor :shimmer="true" height="40" width="100%" />
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <table class="table tablesorter">
              <thead class="thead-light">
                <tr>
                  <th><Skeletor :shimmer="true" height="10" width="100%" /></th>
                  <th v-if="showPromoterColumns">
                    <Skeletor :shimmer="true" height="10" width="100%" />
                  </th>
                  <th v-if="showPromoterColumns">
                    <Skeletor :shimmer="true" height="10" width="100%" />
                  </th>
                  <th v-if="showPromoterColumns">
                    <Skeletor :shimmer="true" height="10" width="100%" />
                  </th>
                  <th><Skeletor :shimmer="true" height="10" width="100%" /></th>
                  <th><Skeletor :shimmer="true" height="10" width="100%" /></th>
                  <th><Skeletor :shimmer="true" height="10" width="100%" /></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td v-if="showPromoterColumns">
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td v-if="showPromoterColumns">
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td v-if="showPromoterColumns">
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                </tr>
                <tr>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td v-if="showPromoterColumns">
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td v-if="showPromoterColumns">
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td v-if="showPromoterColumns">
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                </tr>
                <tr>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td v-if="showPromoterColumns">
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td v-if="showPromoterColumns">
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td v-if="showPromoterColumns">
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="col-6 col-sm-6 col-md-8 col-lg-8 col-xl-8">
            <Skeletor :shimmer="true" height="10" pill width="80%" />
          </div>

          <div class="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4">
            <div class="row">
              <div class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                <Skeletor :shimmer="true" height="10" width="100%" />
              </div>

              <div
                class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"
                align="center"
              >
                <Skeletor :shimmer="true" circle size="30" />
              </div>

              <div class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                <Skeletor :shimmer="true" height="10" width="100%" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <DataTable
        ref="salesTable"
        v-else
        :columns="columns"
        :options="options"
        :data="sales"
        class="table tablesorter"
        width="100%"
      >
        <thead>
          <tr>
            <th data-priority="3">Fecha/Hora</th>
            <th v-if="showPromoterColumns">Vendedor</th>
            <th v-if="showPromoterColumns">Ciudad</th>
            <th v-if="showPromoterColumns">Almacén</th>
            <th data-priority="1">Nombre</th>
            <th>Celular</th>
            <th>Estado</th>
          </tr>
        </thead>
      </DataTable>

      <!-- Modal notas (mismo estilo que administración) -->
      <VueFinalModal
        v-model="showNotesModal"
        :esc-to-close="true"
        class="modal-container"
        content-class="modal-content4"
      >
        <div class="modal__content">
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 8px;
            "
          >
            <h5 style="margin: 0; font-weight: 800; color: #7d0c7e">
              Historial de notas
            </h5>
            <i
              class="fas fa-times-square close_modal"
              style="color: slategray; cursor: pointer"
              @click="closeNotesModal"
            ></i>
          </div>

          <p v-if="selectedSaleForNotes" class="notes-modal-subtitle">
            {{ selectedSaleForNotes.displayName || "Sin nombre" }}
          </p>

          <div v-if="selectedNotes.length > 0" class="notes-list">
            <div
              v-for="(note, index) in selectedNotes"
              :key="index"
              class="notes-list-item"
            >
              <div class="notes-line">
                <div class="notes-line-number">{{ index + 1 }}</div>
                <div class="notes-line-text">
                  <p class="notes-main-text">
                    {{ note.note || "" }}
                  </p>
                </div>
                <div class="notes-line-date" v-if="note.date || note.createdAt">
                  {{ formatNoteDate(note.date || note.createdAt) }}
                </div>
              </div>
            </div>
          </div>
          <p v-else class="notes-empty">
            Esta venta no tiene notas registradas.
          </p>

          <div class="notes-modal-actions">
            <button
              type="button"
              class="btn btn-secondary"
              @click="closeNotesModal"
            >
              Cerrar
            </button>
          </div>
        </div>
      </VueFinalModal>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import DataTable from "datatables.net-vue3";
import DataTablesCore from "datatables.net-bs5";
import "datatables.net-responsive";
import { VueFinalModal } from "vue-final-modal";
import "vue-final-modal/style.css";
import ModalCompletarVenta from "./ModalCompletarVenta.vue";

DataTable.use(DataTablesCore);

export default {
  components: {
    DataTable,
    ModalCompletarVenta,
    VueFinalModal,
  },
  props: ["userId", "tokenAuth", "onDashboard", "registerReferral"],
  data() {
    return {
      loading: true,
      sales: [],
      searchTerm: "",
      showNotesModal: false,
      selectedSaleForNotes: null,
      selectedNotes: [],
      componentKeyModalCompletarVenta: 100,
      idVenta: "",
      showModal: false,
      columns: [],
      options: {
        responsive: true,
        ordering: false,
        lengthMenu: [
          [5, 15, 25, 35, 50, -1],
          [5, 15, 25, 35, 50, "All"],
        ],
        pageLength: 5,
        language: {
          search: "Buscar:",
          sInfo:
            "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
          sInfoEmpty:
            "Mostrando registros del 0 al 0 de un total de 0 registros",
          searchPlaceholder: "Buscar por término...",
          zeroRecords: "No tienes ventas en estado pendiente",
          processing: "Buscando. Espere por favor...",
          sLengthMenu: "Mostrar _MENU_ registros",
          oPaginate: {
            sFirst: "Primero",
            sLast: "Último",
            sNext: "Siguiente",
            sPrevious: "Anterior",
          },
        },
        rowCallback: (row, data) => {
          // Solo estilo: el click se maneja por delegación para que funcione
          // también cuando la columna Estado está en la fila expandida (responsive)
          const statusCell =
            row && row.children ? row.children[row.children.length - 1] : null;
          if (!statusCell) return;

          statusCell.style.cursor = "pointer";
          statusCell.title = "Ver historial de notas";
        },
      },
    };
  },
  computed: {
    isEnterprise() {
      return this.$store.state.user?.type === "enterprise";
    },
    showPromoterColumns() {
      const role = this.$store.state.user?.role;
      return this.isEnterprise && (role === "director" || role === "admin");
    },
  },
  watch: {},
  mounted() {
    this.$eventBus.on("reiniciarModalCompletarVenta", () => {
      this.componentKeyModalCompletarVenta += 1;
      this.showModal = false;
    });

    this._boundStatusCellClick = this._onStatusCellClick.bind(this);
    this.$el.addEventListener("click", this._boundStatusCellClick);

    this.updateColumns();
    this.getListado();
  },
  beforeUnmount() {
    if (this.$el && this._boundStatusCellClick) {
      this.$el.removeEventListener("click", this._boundStatusCellClick);
    }
  },
  methods: {
    updateColumns() {
      const columns = [];

      // Fecha/Hora always first
      columns.push({
        data: "dateFormatted",
        width: this.showPromoterColumns ? "12%" : "15%",
      });

      // Si es enterprise y rol director o admin, mostrar Vendedor, Ciudad, Almacén
      if (this.showPromoterColumns) {
        columns.push(
          {
            data: "promoterFullName",
            width: "12%",
          },
          {
            data: "promoterCity",
            width: "12%",
          },
          {
            data: "promoterBranch",
            width: "12%",
          },
        );
      }

      // Add common columns: Nombre, Celular
      columns.push(
        {
          data: null,
          width: this.showPromoterColumns ? "20%" : "25%",
          render: function (data) {
            return data.displayName || "";
          },
        },
        { data: "phone", width: this.showPromoterColumns ? "12%" : "15%" },
      );

      // Add Estado at the end (render as button)
      columns.push({
        data: null,
        width: this.showPromoterColumns ? "20%" : "30%",
        render: function (data) {
          const status = data.status || "";
          return `<button type="button" class="btn btn-sm btn-status-cell">${status}</button>`;
        },
      });

      this.columns = columns;
    },
    _onStatusCellClick(evt) {
      const btn = evt.target.closest(".btn-status-cell");
      if (!btn) return;
      // Solo si la tabla está montada (no loading) y el click fue dentro de nuestra tabla
      const tableRef = this.$refs.salesTable;
      if (!tableRef?.$el?.contains(btn)) return;

      let tr = btn.closest("tr");
      if (!tr) return;
      // Cuando la columna Estado está oculta por responsive, el botón está en la fila "child"
      if (tr.classList.contains("child")) {
        tr = tr.previousElementSibling;
      }
      if (!tr) return;

      const api =
        tableRef.dt && typeof tableRef.dt.search === "function"
          ? tableRef.dt
          : typeof tableRef.dt === "function"
            ? tableRef.dt()
            : null;
      if (!api) return;

      const row = api.row(tr);
      if (!row.length) return;
      const data = row.data();
      if (!data) return;
      if (
        !data.notes ||
        !Array.isArray(data.notes) ||
        data.notes.length === 0
      ) {
        return;
      }
      evt.stopPropagation();
      this.openNotesModal(data);
    },
    openNotesModal(sale) {
      this.selectedSaleForNotes = sale;
      this.selectedNotes = Array.isArray(sale.notes) ? sale.notes : [];
      this.showNotesModal = true;
    },
    closeNotesModal() {
      this.showNotesModal = false;
      this.selectedSaleForNotes = null;
      this.selectedNotes = [];
    },
    formatNoteDate(rawDate) {
      try {
        // Si ya viene como string formateado (como "13/01/2026, 11:46"), lo devolvemos tal cual
        if (typeof rawDate === "string") {
          return rawDate;
        }

        // Firestore Timestamp
        if (rawDate && typeof rawDate.toDate === "function") {
          const d = rawDate.toDate();
          return d.toLocaleString("es-ES", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          });
        }
        // {_seconds, _nanoseconds}
        if (rawDate && rawDate._seconds) {
          const d = new Date(
            rawDate._seconds * 1000 + (rawDate._nanoseconds || 0) / 1e6,
          );
          return d.toLocaleString("es-ES", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          });
        }
        // ISO string o Date
        const d = rawDate instanceof Date ? rawDate : new Date(rawDate);
        if (!isNaN(d.getTime())) {
          return d.toLocaleString("es-ES", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          });
        }
      } catch (e) {
        // fallback: mostrar raw
      }
      return rawDate || "";
    },
    applySearch() {
      if (!this.isEnterprise) return;

      const tableRef = this.$refs?.salesTable;
      if (!tableRef) return;

      // datatables.net-vue3 exposes the API as `dt` (sometimes as a function returning the API)
      const api =
        tableRef.dt && typeof tableRef.dt.search === "function"
          ? tableRef.dt
          : typeof tableRef.dt === "function"
            ? tableRef.dt()
            : null;

      if (!api || typeof api.search !== "function") return;

      api.search(this.searchTerm || "").draw();
    },
    refresh() {
      this.$eventBus.emit("reiniciarListadoVentas");
    },

    getListado() {
      this.$https
        .post("/sales/fetchSales/", {
          tokenAuth: this.tokenAuth,
          userId: this.userId,
        })
        .then((response) => {
          this.loading = false;

          this.sales = response.data.sales;

          // Filter out sales with status "INSTALADO: Contrato instalado"
          this.sales = this.sales.filter(
            (sale) => sale.status !== "INSTALADO: Contrato instalado",
          );

          // Keep the custom enterprise search applied after data reload
          this.$nextTick(() => this.applySearch());
        })
        .catch((error) => {
          if (error.status === 401) {
            this.$store.dispatch("clearAllData");
            this.$toast.error("Sesión expirada. Inicie sesión nuevamente", {
              position: "top-right",
              max: 10,
            });
            this.$router.push({ name: "Signin" });
          } else if (error.status === 404) {
            this.loading = false;
            return;
          } else {
            this.$toast.error("Ocurrió un error inesperado", {
              position: "top-right",
              max: 10,
            });
          }
          this.loading = false;

          // this.getListado();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "datatables.net-dt";
@import "datatables.net-responsive-dt";

table thead {
  background-color: #7d0c7e; /* Change to your desired background color */
  color: #ffffff; /* Change font color */
}

/* Optional: Target the <th> elements for more specific styling */
table thead th {
  font-weight: bold; /* Make the text bold */
  padding: 10px; /* Adjust padding for better spacing */
  text-align: left; /* Align text if needed */
}

/* If you want to style a specific table */
table.dataTable thead th {
  background-color: #7d0c7e; /* Specific background color for this table */
  color: white; /* Specific font color */
}

:deep(table tbody tr td) {
  font-weight: bold !important;
}

:deep(.btn-status-cell) {
  font-weight: 600;
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 8px;
  border: 1px solid #7d0c7e;
  background: #7d0c7e;
  color: #fff;
  cursor: pointer;
  white-space: normal;
  text-align: center;
  line-height: 1.2;
}

:deep(.btn-status-cell:hover) {
  background: #6a0a6b;
  border-color: #6a0a6b;
  color: #fff;
}

:deep(.form-control.form-control-sm) {
  border: 2px solid #f9cc03;
  background: white;
}

:deep(.dataTables_filter label) {
  color: #7d0c7e;
}

:deep(.dataTables_length label) {
  color: #7d0c7e;
}
:deep(.dataTables_length label select) {
  border: 2px solid #f9cc03;
  background-color: white;
}

:deep(.dataTables_length) {
  display: none;
}

:deep(.dataTables_filter) {
  display: none;
}

/* Modal notas: fila = número (chico) | texto | fecha (chica), borde izquierdo */
.notes-list {
  max-height: 320px;
  overflow-y: auto;
  margin-bottom: 16px;
  padding-left: 12px;
  border-left: 3px solid #7d0c7e;
}

.notes-list-item {
  padding: 6px 0;
  border-bottom: 1px solid #eee;
}

.notes-list-item:last-child {
  border-bottom: none;
}

.notes-line {
  display: grid;
  grid-template-columns: 20px 1fr auto;
  gap: 10px 12px;
  align-items: start;
}

.notes-line-number {
  font-size: 11px;
  font-weight: 600;
  color: #666;
  line-height: 1.3;
}

.notes-line-text {
  font-size: 13px;
  line-height: 1.4;
  white-space: pre-wrap;
  word-break: break-word;
}

.notes-main-text {
  margin: 0;
  font-size: inherit;
}

.notes-line-date {
  font-size: 11px;
  color: #888;
  white-space: nowrap;
  text-align: right;
}

.notes-modal-subtitle {
  margin: 0 0 12px 0;
  font-size: 14px;
  color: #555;
}

.notes-empty {
  font-size: 13px;
  color: #666;
  margin-bottom: 16px;
}

.notes-modal-actions {
  text-align: right;
  margin-top: 16px;
}

.purpleTag {
  padding: 6px 16px;
  background: linear-gradient(135deg, #7d0c7e 0%, #b245b3 100%);
  color: white;
  font-family: "Inter", "Segoe UI", sans-serif;
  font-weight: 600;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(125, 12, 126, 0.25);
  width: fit-content;
  margin: 0 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
}

.purpleTag:hover {
  background: linear-gradient(135deg, #b245b3 0%, #7d0c7e 100%);
  box-shadow: 0 4px 12px rgba(125, 12, 126, 0.35);
}

// .pinkPurpleText {
//   padding: 5px 10px;
//   background: rgb(170, 50, 189);
//   background: linear-gradient(
//     68deg,
//     rgba(170, 50, 189, 1) 0%,
//     rgb(226, 80, 232) 100%
//   );
//   // border: 2px solid #ec62ea;
//   box-shadow: 0 4px 10px -4px rgba(0, 0, 0, 0.5) !important;
//   color: white;
//   font-family: Ubuntu;
//   margin: 0;
//   width: max-content;
//   border-radius: 16px;
//   gap: 8px;
//   margin-top: 8px;
//   font-weight: 900;
//   margin-left: 70px;
//   margin-right: 70px;
//   box-shadow: 0px 2px 10px 2px #bc49be48;
// }

// .pinkPurpleText:hover {
//   background: linear-gradient(
//     68deg,
//     rgb(226, 80, 232) 0%,
//     rgba(170, 50, 189, 1) 100%
//   );
// }
@keyframes scaleAnimation {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.15);
  }
  100% {
    transform: scale(1);
  }
}

.scaling-image {
  max-height: 34px;
  animation: scaleAnimation 1.5s ease-in-out infinite;
}
</style>
